const TALK_TO_US_PATHS = [
  '/',
  '/how-it-works',
  '/who-we-help',
  '/why-were-better',
  '/testimonials',
  '/about',
  '/scam',
]

export const isTalkToUsPath = (asPath) => {
  if (!asPath) return false

  const path =
    asPath
      .split(/[?#]/)[0]
      .replace(/^\/experiment(?=\/)/, '')
      .replace(/\/(control|talk-to-us-variation-a)\/?$/, '')
      .replace(/\/+$/, '') || '/'

  return TALK_TO_US_PATHS.includes(path)
}
